import type { JSX, ReactNode } from 'react';
import React from 'react';

import NavBottomSection from '@feathr/extender/App/Page/PrimaryNav/NavBottomSection';
import { NavigationProvider } from '@feathr/extender/state';

import PrimaryNav from './PrimaryNav';

import * as styles from './PrototypeShell.css';

interface IPrototypeShellProps {
  children: ReactNode;
}

function PrototypeShell({ children }: Readonly<IPrototypeShellProps>): JSX.Element {
  return (
    <NavigationProvider>
      <div className={styles.root}>
        <div className={styles.layout}>
          <aside className={styles.sidebar}>
            <div className={styles.scrollArea}>
              <PrimaryNav />
            </div>
            <NavBottomSection className={styles.navBottom} />
          </aside>
          <main className={styles.main}>{children}</main>
        </div>
      </div>
    </NavigationProvider>
  );
}

export default PrototypeShell;
